
import weekOfYear from 'dayjs/plugin/weekOfYear'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isBetween from 'dayjs/plugin/isBetween'
import minMax from 'dayjs/plugin/minMax'

useDayjs().extend(minMax)
useDayjs().extend(isBetween)
useDayjs().extend(weekOfYear)
useDayjs().extend(isSameOrAfter)
useDayjs().extend(isSameOrBefore)

import * as updateLocale from 'dayjs/plugin/updateLocale' // ES 2015
useDayjs().extend(updateLocale.default)
useDayjs().updateLocale('en', {
  weekStart: 1,
})

export const dayJs = () => {
  const { locale } = useGlobalI18n()
  useDayjs().locale(locale.value)
  return useDayjs()
}
